document.addEventListener('DOMContentLoaded', (event) => {
    console.log("Script started!");

    const currentUrl = window.location.href;
    const veganInUrl = currentUrl.includes('vegan');
    const rangeTabExists = document.querySelector('.range-tabs') !== null;

    // Functions to update the borders
    const applyOriginalBorder = () => {
        const element = document.getElementById('multivariants_setbox_body');
        if (element) {
            element.classList.add('animated-border', 'animated-border-grey');
        }
    };

    const applyVeganBorder = () => {
        const element = document.getElementById('multivariants_setbox_body');
        if (element) {
            element.classList.remove('animated-border-grey'); 
            element.classList.add('animated-border');
        }
    };

    // Event listeners for the buttons
    const originalBtn = document.getElementById("original-range-button");
    if (originalBtn) {
        originalBtn.addEventListener("click", applyOriginalBorder);
    }

    const veganBtn = document.getElementById("vegan-range-button");
    if (veganBtn) {
        veganBtn.addEventListener("click", applyVeganBorder);
    }

    // MutationObserver to check for the dynamic element
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const element = document.getElementById('multivariants_setbox_body');
                if (element && rangeTabExists) {
                    console.log("Element found!");

                    veganInUrl ? applyVeganBorder() : applyOriginalBorder();

                    observer.disconnect(); 
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
